import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, tap, catchError, map } from 'rxjs/operators';

import { Selectors, AppState } from 'store/root-reducer';
import { Role, RoleType } from 'modules/shared/models/role.models';

@Injectable()
export class AdminRoleGuard implements CanActivate {
  constructor(private store: Store<AppState>,
              private router: Router) { }

  getRole(): Observable<boolean> {
    return this.store.select(Selectors.auth.getUserRoles)
      .pipe(
        filter((data: Array<Role>) => !!data.length),
        map((data: Array<Role>) => {
          return data.some((role: Role) => role.name === RoleType.ADMIN) ||
                 data.some((role: Role) => role.name === RoleType.SUPER_ADMIN);
        })
      );
  }

  canActivate(): Observable<boolean> {
    return this.getRole()
      .pipe(
        tap((hasAdminRole: boolean) => {
          if (!hasAdminRole) {
            this.router.navigateByUrl('/page-not-found');
          }
        }),
        catchError((error: any) => of(error.message))
      );
  }
}
